export default __webpack_public_path__ + "static/media/Coach_Trainer_Role.b28211f9.svg";